export default __webpack_public_path__ + "img/45.0a4ae63.svg";